import { useEltSyncQuery } from "@/apollo/types";
import LoadingSpinner from "@/components/elements/LoadingSpinner";
import { WebhookUrlsTable } from "@/components/modules/view-data-source-slideover/WebhookUrlsTable";

export function WebhookSetupCompleteStep({
  eltSyncId,
}: {
  eltSyncId?: string;
}) {
  const { data, loading } = useEltSyncQuery({
    variables: {
      eltSyncId: eltSyncId!, // Skipped when eltSyncId is undefined, so this is safe
    },
    skip: !eltSyncId,
  });

  return (
    <div className="flex flex-col items-start">
      <div className="mb-5 flex w-full flex-col items-center justify-center space-y-5 px-32">
        <p className="text-2xl">Webhook Setup Complete</p>
        <p className="text text-pretty">
          Your webhook integration is ready. Since webhooks are pushed rather
          than pulled, data will only start appearing once you send events to
          the webhook URLs below.
        </p>
        <p className="text text-pretty">
          The sync will keep running on a schedule to pick up new events, so
          there&apos;s nothing else you need to do - just start sending events
          whenever you&apos;re ready.
        </p>
      </div>
      {loading ? (
        <div className="flex w-full items-center justify-center gap-2">
          <p className="text text-pretty">Loading webhook URLs</p>
          <LoadingSpinner className="ml-2 size-4" />
        </div>
      ) : data && data.eltSync.eltWebhookId ? (
        <WebhookUrlsTable
          data={data.eltSync}
          webhookId={data.eltSync.eltWebhookId}
        />
      ) : (
        <div className="flex w-full items-center justify-center gap-2">
          <p className="text text-pretty">
            Error while loading webhook URLs. You can view them on the data
            source page.
          </p>
        </div>
      )}
    </div>
  );
}
